export const basePath = '/app';

export const selectionTileIconSize = { xs: '9vw', lg: '4.5vw' };

export const IJOPOWER_CONTACT_NUMBER = '01209 707 392';
export const IJOPOWER_CALENDY_CALL_LINK = 'https://calendly.com/ijo_power/phone-call-to-discuss-your-ijo-power-quote';
export const IJOPOWER_EMAIL_ADDRESS = 'hello@ijopower.com';
